import { useState } from "react";
import PropTypes from "prop-types";
import Dialog from "../../dialogs/Dialog";
import _ from "lodash";

/**
 * Edit text cell component
 * @module
 * @param {func} onChange - Function invoked on change
 * @param {string} dataItem - Data item
 * @param {string} field - Field
 * @param {string} className - TD Class name
 * @param {number} colSpan - Number of columns which cell expands to
 * @param {object} style - Style
 * @param {number} columnIndex - Column index
 * @param {number} level - Level
 * @param {func} render - Render function
 */
export const editPhoneNoCell = ({ isValueChanged }) => {
  const EditPhoneNoCell = (props) => {
    const { onChange, dataItem, field, tdProps, isInEdit } = props;

    const [value, setValue] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleDialogClose = () => {
      setIsDialogOpen(false);
    };

    const handleDialogOpen = () => {
      setIsDialogOpen(true);
      setValue(dataItem[field] || "");
    };

    const handleDialogConfirm = async (e) => {
      setIsDialogOpen(false);

      onChange({
        dataItem: dataItem,
        field: field,
        syntheticEvent: e,
        value: value,
      });
    };

    const handleFocus = (e) => {
      e.target.selectionStart = 0;
      e.target.selectionEnd = e.target.value.length;
    };

    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.stopPropagation();
      }
      if (e.key === "Escape") {
        setIsDialogOpen(false);
        e.stopPropagation();
      }
    };

    const handleChange = (e) => {
      let element = document.getElementsByClassName("k-grid-edit-cell");
      if (element) {
        if (
          !/([+]\d{3}\s\d{3}\s\d{3}\s\d{3}|[0]{2}\d{3}\s\d{3}\s\d{3}\s\d{3})|(^\d{4}\s\d{3}\s\d{3}$)|(^\d{10}$)|([+]\d{12}|[0]{2}\d{12})|([+]\d{2}\s\d{3}\s\d{3}\s\d{4}|[0]{2}\d{2}\s\d{3}\s\d{3}\s\d{4})|([+]\d{2}\s\d{2}\s\d{4}\s\d{4}|[0]{2}\d{2}\s\d{2}\s\d{4}\s\d{4})|([+]\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2}|[0]{2}\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2})|([0]\d{2}.\d{3}\s\d{2}\s\d{2})|([+]\d{3}\s\d{2}.\d{7}|[0]{2}\d{3}\s\d{2}.\d{7})|([0]\d{2}.\d{7}$)/g.test(
            e.target.value
          )
        ) {
          element[4].classList.add("incomplete-number");
        } else {
          element[4].classList.remove("incomplete-number");
        }
      }

      setValue(e.target.value);

      onChange({
        dataItem: dataItem,
        field: field,
        syntheticEvent: e,
        value: e.target.value,
      });
    };

    const dataValue = _.get(dataItem, field.split(".")) || "";
    return <td
      {...tdProps}
      className={`${tdProps.className} ${isValueChanged && isValueChanged(dataItem, field) ? "k-state-changed" : ""}`}
      tabIndex={0}
    >
      {isInEdit ? (
        <input
          style={{ width: "100%" }}
          onChange={handleChange}
          className={"k-textbox"}
          value={dataValue}
          onDoubleClick={handleDialogOpen}
          onKeyPress={(event) => {
            if (!/^[0-9+ ]+$/.test(event.key)) {
              event.preventDefault();
            }
          }}
          type="tel"
          minLength="10"
          maxLength="13"
        />
      ) : (
        dataValue
      )}
      {isDialogOpen && (
        <Dialog title={"Editácia textu"} isOpen={isDialogOpen} onClose={handleDialogClose} onConfirm={handleDialogConfirm}>
          <textarea
            className="k-textarea"
            value={value}
            onChange={(e) => { setValue(e.target.value) }}
            style={{ width: "100%" }}
            autoFocus={true}
            onFocus={handleFocus}
            onKeyDown={handleKeyDown}
          />
        </Dialog>
      )}
    </td>
  };

  EditPhoneNoCell.propTypes = {
    onChange: PropTypes.func,
    dataItem: PropTypes.object,
    field: PropTypes.string,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    style: PropTypes.object,
    columnIndex: PropTypes.number,
    level: PropTypes.number,
    render: PropTypes.func,
  };

  return EditPhoneNoCell;
};
